module.exports = __webpack_public_path__ + "img/img8.500112fd.png";